import React from "react";

import { Filter, AutocompleteInput, ReferenceInput } from "react-admin";


export const SessionFilter = props => (
    <Filter {...props}>
        <ReferenceInput source="doctor" reference="doctors" label="Clinician" >
            <AutocompleteInput
                optionText={choice => `Clinician ${choice.first_name} ${choice.last_name}`}
            />
        </ReferenceInput>
        <ReferenceInput source='patient' reference='patients'>
            <AutocompleteInput
                optionText={choice => `Patient. ${choice.first_name} ${choice.last_name}`}
            />
        </ReferenceInput>
    </Filter>
)

const deviceFamilyChoices = [
    { id: 1, name: "Powerdot"},
    { id: 2, name: "Theragun"}
];

export const SessionFilterWithDeviceFamily = props => (
    <Filter {...props}>
        <ReferenceInput source="doctor" reference="doctors" label="Clinician" >
            <AutocompleteInput
                optionText={choice => `Clinician ${choice.first_name} ${choice.last_name}`}
            />
        </ReferenceInput>
        <ReferenceInput source='patient' reference='patients'>
            <AutocompleteInput
                optionText={choice => `Patient. ${choice.first_name} ${choice.last_name}`}
            />
        </ReferenceInput>
        <AutocompleteInput
            source="deviceFamily"
            label="Device Family"
            choices={deviceFamilyChoices}
            translateChoice={false}
        />
    </Filter>
)


export const TransferSharingRequestFilter = props => (
    <Filter {...props}>
        <ReferenceInput source="owner" reference="doctors" >
            <AutocompleteInput
                optionText={choice => `Clinician ${choice.first_name} ${choice.last_name}`}
            />
        </ReferenceInput>
        <ReferenceInput source="receiver" reference="doctors" >
            <AutocompleteInput
                optionText={choice => `Clinician ${choice.first_name} ${choice.last_name}`}
            />
        </ReferenceInput>
        <ReferenceInput source='patient' reference='patients'>
            <AutocompleteInput
                optionText={choice => `Patient. ${choice.first_name} ${choice.last_name}`}
            />
        </ReferenceInput>
    </Filter>
)

